/**
 * <blog-slider> (sections/blog-slider.liquid) — D-22 blog-layer port.
 *
 * 1:1 rebuild of live's legacy-prefixed blog-slider module (extracted from
 * live's global JS bundle, src/js/modules path recorded in the piece report;
 * element renamed per the naming gate). Behaviour kept verbatim:
 *
 *  - Swiper on .swiper-container: 3-up desktop; mobile (<768px) 1-up
 *    coverflow with centered slides and -230px spaceBetween — the stacked
 *    "deck" look. `observerParents` is live's spelling (Swiper's real option
 *    is observeParents); it was inert on live and stays inert here — do not
 *    "fix" it into different runtime behaviour.
 *  - Click-to-play video wiring: live queried .video-wrapper DOCUMENT-wide
 *    from every slider instance, so pages with several sliders bind the same
 *    handlers more than once (idempotent actions — play/pause/display).
 *    Kept verbatim for parity.
 *
 * Renames against live, forced by the naming gate — none behavioral:
 *  - custom element tag  -> blog-slider
 *  - Swiper readiness rides window.whenSwiperReady (snippets/swiper-loader.liquid;
 *    precedent: assets/promo-products.js). Live assumed a global Swiper at
 *    DOMContentLoaded because its loader injected earlier; the rebuild's
 *    loader injects AT DOMContentLoaded, so the queue is the equivalent hook.
 */
(() => {
  class BlogSlider extends HTMLElement {
    connectedCallback() {
      this._initializeSwiper();
    }

    _initializeSwiper() {
      const init = () => {
        window.whenSwiperReady(() => {
          new Swiper(this.querySelector('.swiper-container'), {
            slidesPerView: 3,
            navigation: {
              nextEl: this.querySelector('.swiper-button-next'),
              prevEl: this.querySelector('.swiper-button-prev'),
            },
            observer: true,
            observerParents: true,
            grabCursor: false,
            breakpoints: {
              0: {
                slidesPerView: 1,
                initialSlide: 1,
                loop: false,
                effect: 'coverflow',
                centeredSlides: true,
                spaceBetween: -230,
                coverflowEffect: {
                  rotate: 0,
                  stretch: 0,
                  depth: 800,
                  modifier: 1,
                  slideShadows: false,
                },
              },
              768: {
                slidesPerView: 3,
                centeredSlides: false,
                effect: 'slide',
                spaceBetween: 20,
                loop: false,
              },
            },
          });

          const videos = document.querySelectorAll('.video-wrapper');
          videos.forEach((video) => {
            const clickToPlayVideo = video.querySelector('video.click-to-play');
            const playButton = video.querySelector('.deferred-media__poster-button');
            if (!clickToPlayVideo || !playButton) return;
            playButton.addEventListener('click', () => {
              clickToPlayVideo.play();
              clickToPlayVideo.volume = 0.5;
              playButton.style.display = 'none';
            });
            clickToPlayVideo.addEventListener('click', () => {
              clickToPlayVideo.pause();
              playButton.style.display = 'flex';
            });
          });
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    }
  }

  if (!customElements.get('blog-slider')) {
    customElements.define('blog-slider', BlogSlider);
  }
})();
